<template>
    <div id="paintlist-create-page">
        <pre v-if="isDebug" class="debug">
      {{ paintlist }}
    </pre
        >
        <actions-menu>
            <actions-menu-item
                v-if="paintlistIdParam != -1"
                :v4="true"
                icon="arrow-left"
                :action="
                    () =>
                        $router.push(
                            '/optimizedpaintlistview/' + paintlistIdParam
                        )
                "
                :label="trans('pages.paintlist_create.to_paint_order')" />
            <actions-menu-item
                v-if="productIdParam != -1"
                :v4="true"
                icon="arrow-left"
                :action="() => goToProductPage(productIdParam)"
                :label="trans('pages.paintlist_create.to_product')" />
        </actions-menu>
        <loader v-if="loading" />
        <div v-else-if="paintlist && paintshops" class="leftcolumn">
            <h1>
                {{
                    trans('pages.paintlist_create.production_order_paint_work')
                }}
            </h1>
            <div class="paintlistviewkey">
                {{ trans('pages.paintlist_create.production_order_number') }}
            </div>
            <span>{{ paintlist.ID }}</span>
            <br />
            <br />
            <div class="paintlistviewkey">
                {{ trans('pages.paintlist_create.paint_shop') }}
            </div>
            <ui5-select @change="paintshopChanged">
                <ui5-option :value="null" :selected="paintlist == null">
                    ---
                </ui5-option>
                <ui5-option
                    v-for="paintshop in paintshops"
                    :key="'paintshop.' + paintshop.paintshopId"
                    :selected="paintlist.paintshop && paintlist.paintshop.paintshopId == paintshop.paintshopId"
                    :value="paintshop.paintshopId">
                    {{ paintshop.name }}
                </ui5-option>
            </ui5-select>
            <br />
            <br />
            <div class="paintlistviewkey">
                {{ trans('pages.paintlist_create.our_ref') }}
            </div>
            <span id="paintlistcreateref">{{ paintlist.reference }}</span>
            <br />
            <div class="paintlistheader">
                <div class="paintlistviewdiv">
                    <div class="paintlistdivtitle">
                        {{ trans('pages.paintlist_create.color') }}
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlist_create.ral_color') }}
                        </div>
                        <div class="paintlistelementvalue">
                            {{ paintlist.ral }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlist_create.powder_number') }}
                        </div>
                        <div class="paintlistelementvalue">
                            {{ paintlist.poeder }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlist_create.brand') }}
                        </div>
                        <div class="paintlistelementvalue">
                            {{ paintlist.producent }}
                        </div>
                    </div>
                </div>

                <div class="paintlistviewdiv">
                    <div class="paintlistdivtitle">
                        {{ trans('pages.paintlist_create.package_content') }}
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlist_create.total_count') }}
                        </div>
                        <div
                            class="paintlistelementvalue paintlistbold"
                            id="paintlistcreatecount">
                            {{ paintlist.count }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlist_create.total_area') }}
                        </div>
                        <div
                            class="paintlistelementvalue paintlistbold"
                            id="paintlistcreatearea">
                            {{ paintlist.area }}
                            <template v-if="paintlist.area">m&#178;</template>
                        </div>
                    </div>
                </div>
            </div>

            <p>{{ trans('pages.paintlist_create.profiles_in_package') }}</p>
            <div id="paintlistcreate">
                <div
                    v-for="(record, recordIndex) in paintlist.records"
                    :id="'paintlistrecord' + record.ID"
                    class="paintlistrecord">
                    <div class="paintlistleft">
                        <img :src="record.imageSrc" :alt="record.code" />
                    </div>
                    <div class="paintlistcenter">
                        <div class="paintlistred">{{ record.description }}</div>
                        <div class="paintlistdefault">{{ record.code }}</div>
                        <div class="paintlistitalic">
                            {{
                                trans(
                                    'pages.paintlist_create.profile_circumference'
                                )
                            }}
                            {{ record.contour }}
                        </div>
                    </div>
                    <div class="paintlistright">
                        <div class="paintlistbold">
                            {{ trans('pages.paintlist_create.length') }}
                            {{ record.length }}
                        </div>
                        <div class="paintlistbold">
                            {{ trans('pages.paintlist_create.count') }}
                            {{ record.count }}
                        </div>
                        <div class="paintlistitalic">
                            {{
                                trans('pages.paintlist_create.total_area_abbr')
                            }}
                            {{ record.area }} m&#178;
                        </div>
                        <ui5-button
                            @click="
                                $router.push(
                                    '/paintlisteditline/' +
                                        productIdParam +
                                        '/' +
                                        paintlistIdParam +
                                        '/' +
                                        record.ID
                                )
                            ">
                            {{ trans('pages.paintlist_create.adjust_line') }}
                        </ui5-button>
                        <ui5-button @click="deleteRecord(record, recordIndex)">
                            {{ trans('pages.paintlist_create.remove_line') }}
                        </ui5-button>
                    </div>
                </div>
            </div>

            <ui5-button
                class="add-line"
                @click="
                    $router.push(
                        '/paintlistcreateline/' +
                            productIdParam +
                            '/' +
                            paintlistIdParam
                    )
                ">
                {{ trans('pages.paintlist_create.add_line') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import IdParamMixin from '../mixins/id-param';
import IsDebugMixin from '../mixins/is-debug';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import Loader from '../components/loader/Loader';
import optimizedPaintListApi from '../api/optimizedPaintList';
import paintshopApi from '../api/paintshop';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showConfirmDialog, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [
        IdParamMixin('productIdParam', 'paintlistIdParam'),
        IsDebugMixin,
        NavigationFunctionsMixin,
        localization,
    ],
    components: { Loader, ActionsMenu, ActionsMenuItem },
    computed: {
        productIdParam() {
            return this.$route.params.productId;
        },
        paintlistIdParam() {
            return this.$route.params.paintlistId;
        },
    },
    data() {
        return {
            loading: false,
            paintshops: null,
            paintlist: null,
        };
    },
    methods: {
        load() {
            if (this.paintlistIdParam != -1) {
                this.$store.commit(
                    'general/setPageTitle',
                    `${this.trans('pages.paintlist_create.edit_paint_order')} ${
                        this.paintlistIdParam
                    }`,
                    { root: true }
                );
            }
            if (this.productIdParam != -1) {
                this.$store.commit(
                    'general/setPageTitle',
                    `${this.trans(
                        'pages.paintlist_create.new_paint_order_for'
                    )} ${this.productIdParam}`,
                    { root: true }
                );
            }

            const promises = [];
            promises.push(
                paintshopApi
                    .list()
                    .then((response) => {
                        this.paintshops = response.data.data;
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.paintlist_create.paint_shop_list_error'
                            )
                        );
                    })
            );

            promises.push(
                optimizedPaintListApi
                    .fetch(this.paintlistIdParam)
                    .then((response) => {
                        const paintlist = response.data.data;
                        paintlist.records.forEach((record) => {
                            record.imageSrc =
                                Config.url +
                                '/optimizedpaintlist/fetchImageForRecord/?recordId=' +
                                record.ID;
                        });
                        this.paintlist = paintlist;
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.paintlist_create.load_paint_order_error'
                            )
                        );
                    })
            );

            Promise.all(promises).then(() => {
                this.loading = false;
            });
        },
        paintshopChanged($event) {
            const value = $event.detail.selectedOption.value || null;
            optimizedPaintListApi
                .setPaintshop(this.paintlistIdParam, value)
                .then(() => {
                    const paintshop = value
                        ? this.paintshops.find((x) => x.paintshopId == value)
                        : null;
                    this.paintlist.paintshop = paintshop;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.paintlist_create.save_paint_shop_error'
                        )
                    );
                });
        },
        deleteRecord(record, index) {
            showConfirmDialog({
                title: this.trans('pages.paintlist_create.remove_line_title'),
                content: this.trans(
                    'pages.paintlist_create.remove_line_confirm'
                ),
                confirm: () => {
                    optimizedPaintListApi
                        .removeRecord(record.ID)
                        .then(() => {
                            this.$delete(this.paintlist.records, index);
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.paintlist_create.remove_line_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.paintlist_create.yes'),
                cancelButton: this.trans('pages.paintlist_create.no'),
            });
        },
    },
};
</script>
